export class ErrorModel {
    errorId: number;
    messageText: string;
    fatal: boolean;
    index: number;
    resetBet: boolean;
}
